import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { getProducts, money } from "@/lib/api";

const CITIES = ["Atlanta", "Miami", "Los Angeles", "Houston", "New York", "Chicago", "Dallas", "London", "Toronto", "Paris", "Detroit", "Phoenix"];
const NAMES = ["Jordan", "Amara", "Kai", "Zoe", "Marcus", "Layla", "Devon", "Nia", "Andre", "Sasha", "Malik", "Camille"];
const ACTIONS = ["just copped", "added to bag", "is eyeing"];

const rand = (a) => a[Math.floor(Math.random() * a.length)];

export const SocialProof = () => {
  const [products, setProducts] = useState([]);
  const [item, setItem] = useState(null);

  useEffect(() => { getProducts().then(setProducts).catch(() => {}); }, []);

  useEffect(() => {
    if (!products.length) return;
    let show;
    const cycle = () => {
      const p = rand(products.filter((x) => x.available));
      if (!p) return;
      setItem({ id: Date.now(), p, name: rand(NAMES), city: rand(CITIES), action: rand(ACTIONS), mins: 1 + Math.floor(Math.random() * 22) });
      show = setTimeout(() => setItem(null), 5200);
    };
    const first = setTimeout(cycle, 6000);
    const interval = setInterval(cycle, 12000);
    return () => { clearTimeout(first); clearTimeout(show); clearInterval(interval); };
  }, [products]);

  return (
    <div className="fixed bottom-4 left-4 z-40 hidden sm:block pointer-events-none">
      <AnimatePresence>
        {item && (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -30 }}
            transition={{ duration: 0.4 }}
            data-testid="social-proof-toast"
            className="pointer-events-auto bg-[#0A0A0A] text-[#F4F2ED] border border-white/10 shadow-2xl flex items-center gap-3 pr-5 max-w-xs"
          >
            <Link to={`/product/${item.p.handle}`} className="w-14 h-16 bg-[#141414] overflow-hidden shrink-0">
              <img src={item.p.images?.[0]} alt="" className="w-full h-full object-cover" />
            </Link>
            <div className="py-2">
              <p className="font-body text-xs leading-snug">
                <b>{item.name}</b> in {item.city} <span className="text-white/60">{item.action}</span>
              </p>
              <p className="font-display text-[11px] uppercase tracking-wide mt-0.5 truncate max-w-[180px]">{item.p.title}</p>
              <p className="font-mono text-[10px] text-[#FFFFFF] mt-1 flex items-center gap-1"><ShoppingBag size={10} /> {money(item.p.price)} · {item.mins}m ago</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
